import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GLOBAL } from '../global';
import { EstadoNovedad } from '../domain/estado-novedad';

@Injectable({
  providedIn: 'root'
})
export class EstadoNovedadService {
  urlEstadoNovedad: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  constructor(
    public httpClient: HttpClient
  ) {
    this.urlEstadoNovedad = GLOBAL.URL_BASE+'sicaEstadoNovedad';
  }

  getSicaEstadoNovedadByCodigo(codigo:string):any{
    return this.httpClient.get(this.urlEstadoNovedad+'/getSicaEstadoNovedadByCodigo/'+codigo);
  }

  getDataEstadoNovedad() : any {
    return this.httpClient.get(this.urlEstadoNovedad+'/getEstadosNovedad/');
  }

  saveEstadoNovedad(estadoNovedad:EstadoNovedad) : any{
    return this.httpClient.post(this.urlEstadoNovedad+'/saveEstadoNovedad/', estadoNovedad, this.httpOptions);
  }

  updateEstadoNovedad(estadoNovedad:EstadoNovedad) : any{
    return this.httpClient.put(this.urlEstadoNovedad+'/updateEstadoNovedad/', estadoNovedad, this.httpOptions);
  }
  
  findAllByEstadoOrderByDescripcionAsc():any{
    return this.httpClient.get(this.urlEstadoNovedad+'/findAllByEstadoOrderByDescripcionAsc');
  }

}
